module.exports = __webpack_public_path__ + "img/car-insurance-icon.d8ad424a.jpg";